import { User } from "@firebase/auth";
import React, { useContext } from "react";
import { IClientData, ISession } from "./types/dashboard";
import { IUserSettings } from "./api/userApi";
import ru from './translates/ru';
import en from './translates/en';
import ua from './translates/ua';

export interface ICheat{
    debug: boolean;
}

export const AppContext = React.createContext<{
    user: User | null,
    setUser: React.Dispatch<React.SetStateAction<User>>,
    clients: IClientData[],
    setClientsRaw: React.Dispatch<React.SetStateAction<IClientData[]>>,
    sessionsRaw: Record<string, ISession[]>,
    setSessionsRaw: React.Dispatch<React.SetStateAction<Record<string, ISession[]>>>,
    cheat: ICheat,
    setCheat: React.Dispatch<React.SetStateAction<ICheat>>,
    loadClients: ()=>void,
    loadSessions: (clientId: string)=>void,
    fontScaler: number,
    setFontScaler: React.Dispatch<React.SetStateAction<number>>,
    wallpaper: string,
    setWallpaper: (value: string)=>void,
    translate: (key: string) => string,
    currentLanguage: string,
    setCurrentLanguage: React.Dispatch<React.SetStateAction<string>>,
    userTimezone: string,
    setUserTimezone: (timezone: string)=>void,
    userSettings: IUserSettings,
    saveUserSettings: (data:IUserSettings)=>Promise<void>,
    progresses: Record<string, {current:number, total:number, isFailed: boolean, stage?: 'uploading' | 'uploaded' | 'failed'}>,
    uploadSessionFiles: (files: FileList, sessionId: string)=>void,
    loadAllSessions: ()=>Promise<Array<ISession>>,
    isAdmin: boolean,
    updateLocalSession: (sessionData: ISession)=>void,
    addLocalSession: (sessionData: ISession)=>void,
    removeLocalSession: (sessionId: string, clientId: string)=>void
}>({
    user: null,
    setUser: null,
    clients: null,
    setClientsRaw: null,
    sessionsRaw: null,
    setSessionsRaw: null,
    cheat: null,
    setCheat: null,
    loadClients: null,
    loadSessions: null,
    fontScaler: 1,
    setFontScaler: null,
    translate: null,
    currentLanguage: null,
    setCurrentLanguage: null,
    userTimezone: null,
    setUserTimezone: null,
    userSettings: null,
    saveUserSettings: null,
    progresses: null,
    uploadSessionFiles: null,
    wallpaper: null,
    setWallpaper: null,
    loadAllSessions: null,
    isAdmin: null,
    updateLocalSession: null,
    addLocalSession: null,
    removeLocalSession: null
});

export const useAppContext = () => {
    return useContext(AppContext);
};

const languageDictionaries = {
    en: en,
    ru: ru,
    ua: ua
};

export const getTranslation = (language: string, key: string) => {
    const dict = languageDictionaries[language as keyof typeof languageDictionaries] || en;
    return dict[key as keyof typeof dict] || key;
};